import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './router';
import { AuthProvider } from '@features/auth/providers/AuthProvider';
import WebSocketProvider from '@shared/providers/WebSocketProvider';
import { BackendStatusProvider } from '@shared/providers/BackendStatusProvider';

function App() {
  return (
    <BackendStatusProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AuthProvider>
          <WebSocketProvider>
            <AppRouter />
          </WebSocketProvider>
        </AuthProvider>
      </BrowserRouter>
    </BackendStatusProvider>
  );
}

export default App;

